function body_scale_resize(iframe_w, iframe_h, class_name) {
    let rate_win_h = 1;
    let rate_win_w = 1;
    let fixed = 0.00001;

    // if ($(window).height() - fixed * $(window).height() < iframe_h) {
    //     rate_win_h =
    //         ($(window).height() - fixed * $(window).height()) / iframe_h;

    //     $(class_name).css({
    //         transform: "scale(" + rate_win_h + ") translate(-50%, -50%)",
    //     });
    // }

    // if ($(window).width() - fixed * $(window).width() < iframe_w) {
    //     rate_win_w =
    //         ($(window).width() - fixed * $(window).width()) / iframe_w;

    //     $(class_name).css({
    //         transform: "scale(" + rate_win_w + ") translate(-50%, -50%)",
    //     });
    // }

    if ($(window).width() < iframe_w) {
        rate_win_w = ($(window).width() - fixed * $(window).width()) / iframe_w;
        $(class_name).css({
            transform: `scale(${rate_win_w})`,
        });

        if ($(".js-modal-resize").length > 0) {
            $(".js-modal-resize").css({
                transform: `scale(${rate_win_w})`,
            });
        }

        // } else if ($(window).width() > iframe_w) {
        //     fixed = 0.008;
        //     rate_win_w = ($(window).width() - fixed * $(window).width()) / iframe_w;
        //     $(class_name).css({
        //         transform: `scale(${rate_win_w})`,
        //     });
    } else {
        $(class_name).css({
            transform: "scale(1)",
        });

        if ($(".js-modal-resize").length > 0) {
            $(".js-modal-resize").css({
                transform: "scale(1)",
            });
        }
    }
}

$(function () {
    if ($(".js-body-resize-auth").length > 0) {
        body_scale_resize(996, 800, ".x-auth-member");

        $(window).on("resize", function () {
            body_scale_resize(996, 800, ".x-auth-member");
        });
    }

    if ($(".js-body-resize-member").length > 0) {
        body_scale_resize(1460, 850, ".x-member");

        $(window).on("resize", function () {
            body_scale_resize(1460, 850, ".x-member");
        });
    }

    if ($(".js-body-resize-quiz").length > 0) {
        body_scale_resize(1460, 850, ".x-quiz");

        $(window).on("resize", function () {
            body_scale_resize(1460, 850, ".x-quiz");
        });
    }

    if ($(".js-body-resize-leaderboard").length > 0) {
        body_scale_resize(1450, 900, ".x-leaderboard");

        $(window).on("resize", function () {
            body_scale_resize(1450, 900, ".x-leaderboard");
        });
    }

    // if ($(".js-body-resize-gallery").length > 0) {
    //     body_scale_resize(1525, 850, ".x-gallery");

    //     $(window).on("resize", function () {
    //         body_scale_resize(1525, 850, ".x-gallery");
    //     });
    // }

    if ($(".js-auth-member-close").length > 0) {
        $(".js-auth-member-close").click(function (e) {
            parent.blazeIT.hideComponent("ShowPopup_Regis");
            parent.blazeIT.hideComponent("ShowPopup_ResetPass");
        });
    }

    if ($(".js-member-close").length > 0) {
        $(".js-member-close").click(function (e) {
            parent.blazeIT.hideComponent("ShowPopup_Profile");
        });
    }

    if ($(".js-quiz-close").length > 0) {
        $(".js-quiz-close").click(function (e) {
            parent.blazeIT.hideComponent("ShowPopup_Quiz");
        });
    }

    if ($(".js-leaderboard-close").length > 0) {
        $(".js-leaderboard-close").click(function (e) {
            parent.blazeIT.hideComponent("ShowPopup_Leaderboard");
        });
    }

    if ($(".js-gallery-close").length > 0) {
        $(".js-gallery-close").click(function (e) {
            let componentName = $(".js-gallery-close").data("component");
            if (!componentName) {
                return;
            }
            parent.blazeIT.hideComponent(componentName);
        });
    }
});
